import { APPRECIATION_SET_TOTAL } from '../../constant';

const SetAppreciationTotal = (total) => ({
  type: APPRECIATION_SET_TOTAL,
  data: total,
});

export { SetAppreciationTotal };
